<template>
    <div style="max-height: 400px;overflow-y: auto">
      <div style="height: 10px"></div>
      <div v-if="addEditObj.isAdd && selectAdd">
        <div style="height: 30px;color: #999999;font-size: 18px;text-align: center">
          <span>是否添加联系人号码到设备白名单?</span>
        </div>
        <div style="margin: 0 20px">
          <el-table
            :data="oldpersons"
            border
            style="width: 100%"
            highlight-current-row>
            <el-table-column
              type="index"
              label="序号"
              width="50"
              align="center">
            </el-table-column>
            <el-table-column
              prop="name"
              label="姓名"
              min-width="60"
              align="center">
            </el-table-column>
            <el-table-column
              label="性别"
              width="50"
              align="center">
              <template slot-scope="scope">
                <span>{{getSex(scope.row.sex)}}</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="phone"
              label="电话号码"
              min-width="90"
              align="center">
            </el-table-column>
            <el-table-column align="center" label="操作" width="100"  class-name="small-padding fixed-width">
              <template slot-scope="scope">
                <el-button size="mini" type="primary" @click="showAdd(scope.row)">添加</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div style="text-align: center;margin-top: 10px">
          <el-button size="small" @click="closeAddEdit()">取 消</el-button>
          <el-button size="small" type="success" @click="showAddNew()">新 建</el-button>
        </div>
        <div style="height: 20px;"></div>
      </div>
      <div v-if="!selectAdd">
        <el-form size="small" :model="telForm" :rules="telRules" ref="telForm" label-width="80px" class="demo-ruleForm">
          <el-row>
            <el-col :span="14">
              <el-form-item label="姓名" prop="name">
                <el-input v-model="telForm.name"></el-input>
              </el-form-item>
              <el-form-item label="电话" prop="phone">
                <el-input v-model="telForm.phone"></el-input>
              </el-form-item>
              <el-form-item label="IM">
                <el-input v-model="telForm.im_num"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="10">
              <div style="width: 90px;margin: auto">
                <el-upload
                  class="avatar-uploader"
                  action="#"
                  :auto-upload="false"
                  :show-file-list="false"
                  :on-exceed="handleExceed"
                  :before-upload="beforeUpload"
                  :on-change="getFile"
                  list-type="picture"
                  :file-list="fileList">
                  <img v-if="photourl" :src="photourl" class="avatar">
                  <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                </el-upload>
              </div>
              <div style="font-size: 16px;text-align: center;color: #409EFF">
                <span v-if="addEditObj.isAdd">上传头像</span>
                <span v-else>更新头像</span>
              </div>
              <div style="font-size: 14px;text-align: center;color: #999999"><span>jpeg/jpg/png格式，且不超过300KB</span></div>
            </el-col>
          </el-row>
<!--          <el-form-item label="头像">-->
<!--            <el-input v-model="telForm.uri"></el-input>-->
<!--          </el-form-item>-->
        </el-form>
<!--        <div style="text-align: center">-->
<!--          <el-button @click="closeAddEdit()">取 消</el-button>-->
<!--          <el-button type="primary" @click="submitAddEdit('telForm')">确 定</el-button>-->
<!--        </div>-->
        <div>
          <el-row style="margin: 0 100px">
            <el-col :span="12">
              <div class="cancel-btn" @click="closeAddEdit()">
                <span>取消</span>
              </div>
            </el-col>
            <el-col :span="12">
              <div class="send-btn" @click="submitAddEdit('telForm')">
                <span>确定</span>
              </div>
            </el-col>
          </el-row>
        </div>
        <div style="height: 20px"></div>
      </div>
    </div>
</template>

<script>
import {adddevicephonebook, updatedevicephonebook} from '../../../api/device'
import {updatefile} from '../../../api/upload'

export default {
  name: 'addEditTel',
  model: {
    prop: 'addEditShow',
    event: 'change'
  },
  props: {
    addEditObj: {
      type: Object
    }
  },
  data () {
    return {
      telForm: {
        id: 0,
        imei: '',
        phone: '',
        name: '',
        uri: '',
        im_num: '',
        remark: '',
        did: ''
      },
      telRules: {
        name: [
          { required: true, message: '请输入姓名', trigger: 'blur' }
        ],
        phone: [
          { required: true, message: '请输入电话号码', trigger: 'blur' }
        ],
        uri: [
          { required: true, message: '请输入头像待定', trigger: 'blur' }
        ],
        im_num: [
          { required: true, message: '请输入IM', trigger: 'blur' }
        ],
        remark: [
          { required: true, message: '请输入关系', trigger: 'blur' }
        ]
      },
      selectAdd: true,
      oldpersons: [],
      photourl: '',
      fileList: [],
      imageUrl: ''
    }
  },
  created () {
    this.telForm.imei = this.addEditObj.device.deviceid
    this.telForm.did = this.addEditObj.device.id
    if (this.addEditObj.isAdd) {
      this.telForm.id = 0
      this.oldpersons = this.addEditObj.oldpersons
      if (this.oldpersons.length === 0) {
        this.selectAdd = false
      }
    } else { // 编辑
      this.telForm.id = this.addEditObj.row.id
      this.telForm.phone = this.addEditObj.row.phone
      this.telForm.name = this.addEditObj.row.name
      let arr = ['.png', '.jpg', '.jpeg']
      for (let i = 0; i < arr.length; i++) {
        if (this.addEditObj.row.uri.includes(arr[i])) {
          this.telForm.uri = this.addEditObj.row.uri
        }
      }
      // this.telForm.uri = this.addEditObj.row.uri
      this.photourl = this.telForm.uri
      this.telForm.im_num = this.addEditObj.row.im_num
      this.telForm.remark = this.addEditObj.row.remark
      this.selectAdd = false
    }
  },
  methods: {
    handleExceed (files, fileList) {
      this.$message.warning(`当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`)
    },
    // 头像
    beforeUpload (file) {
      console.log(111, file, file.type)
    },
    getFile (file, fileList) {
      const isPNG = file.raw.type === 'image/png'
      const isLt2M = file.size / 1024 < 300
      if (!isPNG) {
        this.$message.error('上传头像图片只能是 PNG 格式!')
      }
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 300KB!')
      }
      if (isPNG && isLt2M) {
        this.getBase64(file.raw).then(res => {
          this.photourl = res
          this.imageUrl = res
          this.uploadAvatar()
        })
      }
    },
    uploadAvatar () {
      let arr = this.imageUrl.split(',')
      let data = {
        datatype: 'image',
        data: arr[1]
      }
      updatefile(data).then(res => {
        this.telForm.uri = res.data.fileurl
        this.$message({
          message: '成功上传头像',
          type: 'success'
        })
      }).catch(() => {
        this.photourl = ''
        this.imageUrl = ''
      })
    },
    getBase64 (file) {
      return new Promise(function (resolve, reject) {
        let reader = new FileReader()
        let imgResult = ''
        reader.readAsDataURL(file)
        reader.onload = function () {
          imgResult = reader.result
        }
        reader.onerror = function (error) {
          reject(error)
        }
        reader.onloadend = function () {
          resolve(imgResult)
        }
      })
    },
    getSex (sex) {
      return this.util.getSex(sex + '')
    },
    showAddNew () {
      this.selectAdd = false
    },
    showAdd (row) {
      this.telForm.phone = row.phone
      this.telForm.name = row.name
      this.selectAdd = false
    },
    submitAddEdit (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let data = {
            id: this.telForm.id,
            imei: this.telForm.imei,
            phone: this.telForm.phone,
            name: this.telForm.name,
            uri: this.telForm.uri,
            im_num: this.telForm.im_num,
            remark: this.telForm.remark,
            did: this.telForm.did
          }
          if (this.addEditObj.isAdd) {
            adddevicephonebook(data).then(res => {
              this.$notify({
                title: '成功',
                message: '成功添加白名单',
                type: 'success',
                duration: 2000
              })
              this.$emit('getFather')
              this.$emit('change', false)
            }).catch(() => {})
          } else {
            updatedevicephonebook(data).then(res => {
              this.$notify({
                title: '成功',
                message: '成功编辑白名单',
                type: 'success',
                duration: 2000
              })
              this.$emit('getFather')
              this.$emit('change', false)
            }).catch(() => {})
          }
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    closeAddEdit () {
      this.$emit('change', false)
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/datamanagement/childComponents/addEditTel.vue